function initCatalogueSearch() {
    const input = document.querySelector('[data-catalogue-search]');
    const count = document.querySelector('[data-catalogue-count]');
    const empty = document.querySelector('[data-catalogue-empty]');
    const cards = Array.from(document.querySelectorAll('[data-catalogue-card]'));
    const sections = Array.from(document.querySelectorAll('[data-catalogue-section]'));
    const filters = Array.from(document.querySelectorAll('[data-catalogue-filter]'));
    const brandButtons = Array.from(document.querySelectorAll('[data-catalogue-brand-filter]'));
    const reset = document.querySelector('[data-catalogue-reset-filters]');

    if (!input || cards.length === 0) {
        return;
    }

    const splitValue = (value) => (value || '').split('|').filter(Boolean);
    const selectedValues = (filter) => {
        if (filter.multiple) {
            return Array.from(filter.selectedOptions).map((option) => option.value).filter(Boolean);
        }

        return filter.value ? [filter.value] : [];
    };

    const cardMatchesFilters = (card) => {
        const selectedBrands = brandButtons
            .filter((button) => button.classList.contains('is-active'))
            .map((button) => button.dataset.catalogueBrandFilter);

        const values = {
            brand: card.dataset.brand || '',
            spf: card.dataset.spf || '',
            volume: card.dataset.volume || '',
            productTypes: splitValue(card.dataset.productTypes),
            audienceTags: splitValue(card.dataset.audienceTags),
            areas: splitValue(card.dataset.areas),
            isNew: card.dataset.isNew === '1',
            isPromo: card.dataset.isPromo === '1',
        };

        if (selectedBrands.length > 0 && !selectedBrands.includes(values.brand)) {
            return false;
        }

        return filters.every((filter) => {
            const name = filter.dataset.catalogueFilter;

            if (filter.type === 'checkbox') {
                return !filter.checked || values[name] === true;
            }

            const selected = selectedValues(filter);

            if (selected.length === 0) {
                return true;
            }

            if (Array.isArray(values[name])) {
                return selected.some((value) => values[name].includes(value));
            }

            return selected.includes(values[name]);
        });
    };

    const apply = () => {
        const term = input.value.trim().toLocaleLowerCase();
        let visible = 0;

        cards.forEach((card) => {
            const matchedSearch = term === '' || card.dataset.search.includes(term);
            const matched = matchedSearch && cardMatchesFilters(card);
            card.classList.toggle('d-none', !matched);
            if (matched) {
                visible += 1;
            }
        });

        sections.forEach((section) => {
            const hasVisibleCard = section.querySelector('[data-catalogue-card]:not(.d-none)') !== null;
            section.classList.toggle('d-none', !hasVisibleCard);
        });

        if (count) {
            count.textContent = term === '' ? `${cards.length} προϊόντα συνολικά` : `${visible} αποτελέσματα`;
        }

        if (empty) {
            empty.classList.toggle('d-none', visible > 0);
        }
    };

    input.addEventListener('input', apply);
    filters.forEach((filter) => filter.addEventListener('change', apply));
    brandButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const active = !button.classList.contains('is-active');
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
            apply();
        });
    });

    if (reset) {
        reset.addEventListener('click', () => {
            filters.forEach((filter) => {
                if (filter.type === 'checkbox') {
                    filter.checked = false;
                } else if (filter.multiple) {
                    Array.from(filter.options).forEach((option) => {
                        option.selected = false;
                    });
                } else {
                    filter.value = '';
                }
            });
            brandButtons.forEach((button) => {
                button.classList.remove('is-active');
                button.setAttribute('aria-pressed', 'false');
            });
            apply();
        });
    }
}

document.addEventListener('DOMContentLoaded', initCatalogueSearch);
